import { render, staticRenderFns } from "./UserRegistrationTile.vue?vue&type=template&id=573d34c0&scoped=true&"
import script from "./UserRegistrationTile.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationTile.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistrationTile.vue?vue&type=style&index=0&id=573d34c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d34c0",
  null
  
)

export default component.exports